const CurrentWorkflowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g id="Group_8104" data-name="Group 8104">
                <path
                    id="Path_3405"
                    data-name="Path 3405"
                    d="M17.929.375H1.546A1.181,1.181,0,0,0,.375,1.568V14.217A1.181,1.181,0,0,0,1.546,15.41H13.863a1.17,1.17,0,0,1,.907.437l2.254,2.81A1.166,1.166,0,0,0,19.1,17.9V1.568A1.181,1.181,0,0,0,17.929.375Z"
                    transform="translate(0.263 0.264)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3406"
                    data-name="Path 3406"
                    d="M11.633,3.056,7.09,9.112,3.3,5.075"
                    transform="translate(2.32 2.146)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default CurrentWorkflowIcon;
